import Radio from 'antd/es/radio';
import 'antd/lib/radio/style';
export default Radio;
